module.exports = __webpack_public_path__ + "img/job-position.a9760271.svg";